import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "24",
  width: "24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.409 0.659A2.25 2.25 0 0 1 3 0h15a2.25 2.25 0 0 1 1.568 0.637l0.003 0.002 2.996 2.88 0.003 0.003a2.25 2.25 0 0 1 0.68 1.61V21.75A2.25 2.25 0 0 1 21 24H3a2.25 2.25 0 0 1 -2.25 -2.25V2.25c0 -0.597 0.237 -1.169 0.659 -1.591ZM16 19.25a1 1 0 1 0 0 -2H8a1 1 0 1 0 0 2h8Zm1 -9.5a1 1 0 0 1 -1 1h-3v3a1 1 0 1 1 -2 0v-3H8a1 1 0 1 1 0 -2h3v-3a1 1 0 1 1 2 0v3h3a1 1 0 0 1 1 1Z",
      "clip-rule": "evenodd",
      "stroke-width": "1"
    }, null, -1)
  ])))
}
export default { render: render }